// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0cglyw{display:none}
._3um015vq{visibility:hidden}
._tzy4idpf{opacity:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/common/ToneSelector.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,SAAS","sourcesContent":["._1e0cglyw{display:none}\n._3um015vq{visibility:hidden}\n._tzy4idpf{opacity:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
